import { addDays as addDaysToDate } from 'date-fns';
import format from 'date-fns/format';

export const formatIso = (date: Date, dateFormat = 'yyyy-MM-dd') => format(date, dateFormat);

export const addDays = (date: Date, amount: number) => addDaysToDate(date, amount);

export const daysFromToday = (amount: number) => addDays(new Date(), amount);
